// The assistant dispatches its tool calls through the generated RTK Query endpoints, whose
// prepareHeaders can't otherwise distinguish an agent-initiated request from a normal UI one.
// runEndpointTool records the operationId it is about to dispatch here; prepareHeaders reads it and
// tags the matching request with AGENT_TOOL_HEADER so the BFF can enforce its server-side tool
// allowlist. The agent loop is sequential and prepareHeaders only tags a request whose endpoint
// matches the in-flight operationId, so the only possible overlap is a concurrent UI call to the
// same (therefore allowlisted) endpoint — which the BFF accepts anyway.
export const AGENT_TOOL_HEADER = "x-sm-tool";

let inFlightOperationId: string | null = null;

export const withAgentToolHeader = async <T>(operationId: string, run: () => Promise<T>): Promise<T> => {
  if (inFlightOperationId !== null) {
    // Parallel tool calls would overwrite each other's in-flight id, leaving requests untagged and
    // silently outside the BFF's allowlist enforcement. The agent loop is sequential by design;
    // fail loudly if a refactor ever breaks that invariant.
    throw new Error(`Concurrent agent tool calls are not supported (${inFlightOperationId} is in flight)`);
  }
  inFlightOperationId = operationId;
  try {
    return await run();
  } finally {
    inFlightOperationId = null;
  }
};

export const agentToolInFlight = (): string | null => inFlightOperationId;
